import { Container, Typography } from '@mui/material'
import { format } from 'date-fns'
import { useParams } from 'react-router-dom'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import LoadingScreen from 'src/components/MUIBased/LoadingScreen'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { CarePlanPrompt } from 'src/pages/MUIBased/LabResults/LabResultDetail/components/CarePlanPrompt'
import { ContactCareTeam } from 'src/pages/MUIBased/LabResults/LabResultDetail/components/ContactCareTeam'
import { NonNumericalLabResult } from 'src/pages/MUIBased/LabResults/LabResultDetail/components/NonNumericalLabResult'
import { NumericalLabResult } from 'src/pages/MUIBased/LabResults/LabResultDetail/components/NumericalLabResult'
import { useGetLabResultDetails } from 'src/pages/MUIBased/LabResults/LabResultDetail/hooks/useGetLabResultDetails'
import { searchResultsToRows } from 'src/pages/MUIBased/LabResults/utils/searchResultsToRows'

const LabResultDetail = () => {
    const { observationId } = useParams<{ observationId: string }>()
    const { resultDetails: loaderResults, isLoading } = useGetLabResultDetails(
        observationId ?? ''
    )
    const labResults = searchResultsToRows(loaderResults)
    const labResult = labResults.find(result => result.id === observationId)

    if (isLoading) {
        return <LoadingScreen isLoading />
    }

    if (!labResult) {
        return (
            <Body>
                <StandardPageHeader />
                <NavBarHeading href="/your-care/lab-results">
                    Lab Results
                </NavBarHeading>
                <Container>
                    <ContainerTitle
                        title="Lab Result Not Found"
                        description="The requested lab result could not be found."
                    />
                </Container>
            </Body>
        )
    }

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading href="/your-care/lab-results">
                Lab Results
            </NavBarHeading>

            <Container>
                {/* Date */}
                <Typography variant="overline" color="text.secondary">
                    {labResult.orderDate
                        ? format(
                              labResult.orderDate,
                              'MMMM d, yyyy'
                          ).toUpperCase()
                        : ''}
                </Typography>

                {/*Test Name 
                TODO: Consolidate heading styles with a component or variant*/}
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 700,
                        fontSize: '1.5rem',
                        lineHeight: '32px'
                    }}
                >
                    {labResult.test}
                </Typography>

                {/* Provider */}
                <Typography variant="body2" color="text.secondary">
                    {labResult.requester}
                </Typography>
                {/* Lab performer */}
                <Typography variant="body2" color="text.secondary">
                    {labResult.labPerformer}
                </Typography>
                {labResult.results?.map((res, index) => {
                    if (!res.valueQuantity) {
                        return (
                            <NonNumericalLabResult
                                key={index}
                                labResult={res}
                            />
                        )
                    } else {
                        return (
                            <NumericalLabResult key={index} labResult={res} />
                        )
                    }
                })}

                <CarePlanPrompt />
                <ContactCareTeam />
            </Container>
        </Body>
    )
}

export default LabResultDetail
